import React from 'react';
import { Checkbox as AntCheckbox } from 'antd';

const Checkbox = ({ value, onChange, ...props }) => {
  return (
    <AntCheckbox
      {...props}
      checked={value}
      onChange={(e) => onChange({ isNotFinal: e.target.checked })}
    >
      Предварительная
    </AntCheckbox>
  );
};

export default Checkbox;
